import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FullPageWithCenterContentV2 from "../../../../pages/container/FullPageWithCenterContentV2";
import { theme } from "../../../../styles/theme";
import { Box, CircularProgress } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { webTestTypeAtom } from "../../../../recoil/webTestTypeAtom";
import { userSimpleAtom } from "../../../../recoil/userSimpleAtom";
import { useOnboardingProgress } from "../../../../hooks/useOnboardingProgress";
import useMixpanelMKT from "../../../../hooks/useMixpanelMKT";
import {
  readLastStep,
  writeLastStep,
} from "../../../../utils/promotionOnboardingStorage";
import { usePrevious } from "../../../../hooks/usePrevious";
import FullPageWithHeaderAndProgress from "../../../../pages/container/FullPageWithHeaderAndProgress";

// Start pages
import Start_1_V6 from "../../../../pages/onboarding/v6/start/Start_1_V6";
import Start_2_V6 from "../../../../pages/onboarding/v6/start/Start_2_V6";
import Start_3_V6 from "../../../../pages/onboarding/v6/start/Start_3_V6";
import Start_4_V6 from "../../../../pages/onboarding/v6/start/Start_4_V6";
import Start_5_V6 from "../../../../pages/onboarding/v6/start/Start_5_V6";
import Start_6_V6 from "../../../../pages/onboarding/v6/start/Start_6_V6";
import Start_7_V6 from "../../../../pages/onboarding/v6/start/Start_7_V6";
import Start_8_V6 from "../../../../pages/onboarding/v6/start/Start_8_V6";
import Start_9_V6 from "../../../../pages/onboarding/v6/start/Start_9_V6";

// Goal pages
import Goal_1_V6 from "../../../../pages/onboarding/v6/goal/Goal_1_V6";
import Goal_2_V6 from "../../../../pages/onboarding/v6/goal/Goal_2_V6";
import Goal_3_V6 from "../../../../pages/onboarding/v6/goal/Goal_3_V6";
import Goal_4_V6 from "../../../../pages/onboarding/v6/goal/Goal_4_V6";
import Goal_5_V6 from "../../../../pages/onboarding/v6/goal/Goal_5_V6";
import Goal_6_V6 from "../../../../pages/onboarding/v6/goal/Goal_6_V6";
import Goal_7_V6 from "../../../../pages/onboarding/v6/goal/Goal_7_V6";
import Goal_8_V6 from "../../../../pages/onboarding/v6/goal/Goal_8_V6";
import Goal_9_V6 from "../../../../pages/onboarding/v6/goal/Goal_9_V6";
import Goal_10_V6 from "../../../../pages/onboarding/v6/goal/Goal_10_V6";
import Goal_11_V6 from "../../../../pages/onboarding/v6/goal/Goal_11_V6";
import Goal_12_V6 from "../../../../pages/onboarding/v6/goal/Goal_12_V6";
import Goal_13_V6 from "../../../../pages/onboarding/v6/goal/Goal_13_V6";
import Goal_14_V6 from "../../../../pages/onboarding/v6/goal/Goal_14_V6";
import Goal_15_V6 from "../../../../pages/onboarding/v6/goal/Goal_15_V6";
import Goal_16_V6 from "../../../../pages/onboarding/v6/goal/Goal_16_V6";
import Goal_17_V6 from "../../../../pages/onboarding/v6/goal/Goal_17_V6";

// Convention pages
import Convention_1_V6 from "../../../../pages/onboarding/v6/convention/Convention_1_V6";
import Convention_2_QnA_V6 from "../../../../pages/onboarding/v6/convention/Convention_2_QnA_V6";
import Convention_3_V6 from "../../../../pages/onboarding/v6/convention/Convention_3_V6";
import Convention_4_V6 from "../../../../pages/onboarding/v6/convention/Convention_4_V6";

// Habit pages
import Habit_1_V6 from "../../../../pages/onboarding/v6/habit/Habit_1_V6";
import Habit_2_QnA_V6 from "../../../../pages/onboarding/v6/habit/Habit_2_QnA_V6";
import Habit_3_V6 from "../../../../pages/onboarding/v6/habit/Habit_3_V6";
import Habit_4_V6 from "../../../../pages/onboarding/v6/habit/Habit_4_V6";
import Habit_5_V6 from "../../../../pages/onboarding/v6/habit/Habit_5_V6";
import Habit_6_V6 from "../../../../pages/onboarding/v6/habit/Habit_6_V6";
import Habit_7_V6 from "../../../../pages/onboarding/v6/habit/Habit_7_V6";
import Habit_8_V6 from "../../../../pages/onboarding/v6/habit/Habit_8_V6";
import Habit_9_V6 from "../../../../pages/onboarding/v6/habit/Habit_9_V6";
import Habit_10_V6 from "../../../../pages/onboarding/v6/habit/Habit_10_V6";
import Habit_11_V6 from "../../../../pages/onboarding/v6/habit/Habit_11_V6";
import Habit_12_V6 from "../../../../pages/onboarding/v6/habit/Habit_12_V6";
import Habit_13_V6 from "../../../../pages/onboarding/v6/habit/Habit_13_V6";

// Approach pages
import Approach_1_V6 from "../../../../pages/onboarding/v6/approach/Approach_1_V6";
import Approach_2_V6 from "../../../../pages/onboarding/v6/approach/Approach_2_V6";
import Approach_3_V6 from "../../../../pages/onboarding/v6/approach/Approach_3_V6";
import Approach_4_V6 from "../../../../pages/onboarding/v6/approach/Approach_4_V6";
import Approach_5_V6 from "../../../../pages/onboarding/v6/approach/Approach_5_V6";
import Approach_6_V6 from "../../../../pages/onboarding/v6/approach/Approach_6_V6";
import Approach_7_V6 from "../../../../pages/onboarding/v6/approach/Approach_7_V6";
import Approach_8_V6 from "../../../../pages/onboarding/v6/approach/Approach_8_V6";
import Approach_9_V6 from "../../../../pages/onboarding/v6/approach/Approach_9_V6";
import Approach_5a_V6 from "../../../../pages/onboarding/v6/approach/Approach_5a_V6";
import Approach_8a_V6 from "../../../../pages/onboarding/v6/approach/Approach_8a_V6";

// Motivation pages
import Motivation_1_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_1_V6";
import Motivation_2_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_2_V6";
import Motivation_3_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_3_V6";
import Motivation_4_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_4_V6";
import Motivation_5_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_5_V6";
import Motivation_6_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_6_V6";
import Motivation_7_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_7_V6";
import Motivation_8_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_8_V6";
import Motivation_9_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_9_V6";
import Motivation_10_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_10_V6";
import Motivation_11_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_11_V6";
import Motivation_12_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_12_V6";
import Motivation_13_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_13_V6";
import Motivation_14_V6 from "../../../../pages/onboarding/v6/motivation/Motivation_14_V6";

// Result pages
import Result_1_V6 from "../../../../pages/onboarding/v6/result/Result_1_V6";
import Result_2_V6 from "../../../../pages/onboarding/v6/result/Result_2_V6";
import Result_3_V6 from "../../../../pages/onboarding/v6/result/Result_3_V6";
import Result_4_V6 from "../../../../pages/onboarding/v6/result/Result_4_V6";
import Curriculum_1_V6 from "../../../../pages/onboarding/v6/curriculum/Curriculum_1_V6";

// Product & Payment (V6)
import ProductContentV6 from "./ProductContentV6";
import PaymentContentV6 from "./PaymentContentV6";

// Demographic pages
import CrossFunnel_Loading_V6 from "../../../../pages/onboarding/v6/crossFunnel/CrossFunnel_Loading_V6";
import NicknameSubmitV6 from "../../../../pages/onboarding/v6/nickname/NicknameSubmitV6";
import Demographic_2_V6 from "../../../../pages/onboarding/v6/demographic/Demographic_2_V6";
import Demographic_3_V6 from "../../../../pages/onboarding/v6/demographic/Demographic_3_V6";
import Demographic_4_V6 from "../../../../pages/onboarding/v6/demographic/Demographic_4_V6";

const V6 = "v6" as const;

interface OnboardingStep {
  type: string;
  seqByType: number;
  title?: string;
  hideHeader?: boolean;
  hideProgress?: boolean;
  disableBack?: boolean;
  progressDelta?: number;
  centerFullScreen?: boolean;
  backgroundColor?: string;
  content: React.ReactNode;
}

const commonPrefixSteps: OnboardingStep[] = [
  {
    type: "start",
    seqByType: 1,
    disableBack: true,
    hideHeader: true,
    hideProgress: true,
    content: <Start_1_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 2,
    hideProgress: true,
    content: <Start_2_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 3,
    hideProgress: true,
    content: <Start_3_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 4,
    hideProgress: true,
    content: <Start_4_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 5,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Start_5_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 6,
    hideProgress: true,
    content: <Start_6_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Start_7_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 8,
    hideProgress: true,
    content: <Start_8_V6 version={V6} />,
  },
  {
    type: "start",
    seqByType: 9,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Start_9_V6 version={V6} />,
  },
];

const demographicSteps: OnboardingStep[] = [
  {
    type: "auth-loading",
    seqByType: 1,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <CrossFunnel_Loading_V6 />,
  },
  {
    type: "nickname",
    seqByType: 1,
    disableBack: true,
    hideProgress: true,
    content: <NicknameSubmitV6 />,
  },
  {
    type: "demographic",
    seqByType: 2,
    hideProgress: true,
    content: <Demographic_2_V6 version={V6} />,
  },
  {
    type: "demographic",
    seqByType: 3,
    hideProgress: true,
    content: <Demographic_3_V6 version={V6} />,
  },
  {
    type: "demographic",
    seqByType: 4,
    hideProgress: true,
    content: <Demographic_4_V6 version={V6} />,
  },
];

const mainContentSteps: OnboardingStep[] = [
  {
    type: "goal",
    seqByType: 1,
    title: "고민과 목표",
    disableBack: true,
    progressDelta: 1 / 11,
    content: <Goal_1_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 2,
    title: "고민과 목표",
    progressDelta: 2 / 11,
    content: <Goal_2_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 3,
    title: "고민과 목표",
    progressDelta: 3 / 11,
    content: <Goal_3_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 4,
    title: "고민과 목표",
    progressDelta: 4 / 11,
    content: <Goal_4_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 5,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_5_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 6,
    title: "고민과 목표",
    progressDelta: 5 / 11,
    content: <Goal_6_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 7,
    title: "고민과 목표",
    progressDelta: 6 / 11,
    content: <Goal_7_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 8,
    title: "고민과 목표",
    progressDelta: 7 / 11,
    content: <Goal_8_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 9,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_9_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 10,
    title: "고민과 목표",
    progressDelta: 8 / 11,
    content: <Goal_10_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 11,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_11_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 12,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_12_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 13,
    title: "고민과 목표",
    progressDelta: 9 / 11,
    content: <Goal_13_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 14,
    title: "고민과 목표",
    progressDelta: 10 / 11,
    content: <Goal_14_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 15,
    hideProgress: true,
    content: <Goal_15_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 16,
    hideHeader: true,
    hideProgress: true,
    content: <Goal_16_V6 version={V6} />,
  },
  {
    type: "goal",
    seqByType: 17,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_17_V6 version={V6} />,
  },
  {
    type: "convention",
    seqByType: 1,
    title: "인식과 기대",
    disableBack: true,
    progressDelta: 1 / 20,
    content: <Convention_1_V6 version={V6} />,
  },
  {
    type: "convention",
    seqByType: 2,
    title: "인식과 기대",
    progressDelta: 1 / 20,
    content: <Convention_2_QnA_V6 version={V6} />,
  },
  {
    type: "convention",
    seqByType: 3,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Convention_3_V6 version={V6} />,
  },
  {
    type: "convention",
    seqByType: 4,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Convention_4_V6 version={V6} />,
  },
];

const habitContentSteps: OnboardingStep[] = [
  {
    type: "habit",
    seqByType: 1,
    title: "습관과 노력",
    disableBack: true,
    progressDelta: 1 / 12,
    content: <Habit_1_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 2,
    title: "습관과 노력",
    progressDelta: 1 / 12,
    content: <Habit_2_QnA_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 3,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_8_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 4,
    hideProgress: true,
    content: <Habit_3_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 5,
    hideHeader: true,
    hideProgress: true,
    content: <Habit_4_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 6,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_5_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_9_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 8,
    title: "습관과 노력",
    progressDelta: 10 / 12,
    content: <Habit_10_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 9,
    title: "습관과 노력",
    progressDelta: 11 / 12,
    content: <Habit_11_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 10,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_12_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 11,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_6_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 12,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_7_V6 version={V6} />,
  },
  {
    type: "habit",
    seqByType: 13,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_13_V6 version={V6} />,
  },
];

const approachContentSteps: OnboardingStep[] = [
  {
    type: "approach",
    seqByType: 1,
    title: "관점과 방식",
    disableBack: true,
    progressDelta: 1 / 8,
    content: <Approach_1_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 2,
    title: "관점과 방식",
    progressDelta: 2 / 8,
    content: <Approach_4_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 3,
    title: "관점과 방식",
    progressDelta: 3 / 8,
    content: <Approach_2_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 4,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Approach_3_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 5,
    title: "관점과 방식",
    progressDelta: 4 / 8,
    content: <Approach_5a_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 6,
    title: "관점과 방식",
    progressDelta: 5 / 8,
    content: <Approach_5_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Approach_6_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 8,
    title: "관점과 방식",
    progressDelta: 6 / 8,
    content: <Approach_8a_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 9,
    title: "관점과 방식",
    progressDelta: 7 / 8,
    content: <Approach_7_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 10,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Approach_8_V6 version={V6} />,
  },
  {
    type: "approach",
    seqByType: 11,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Approach_9_V6 version={V6} />,
  },
];

const motivationContentSteps: OnboardingStep[] = [
  {
    type: "motivation",
    seqByType: 1,
    title: "의지와 동기",
    disableBack: true,
    progressDelta: 1 / 10,
    content: <Motivation_1_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 2,
    title: "의지와 동기",
    progressDelta: 2 / 10,
    content: <Motivation_2_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 3,
    title: "의지와 동기",
    progressDelta: 3 / 10,
    content: <Motivation_3_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 4,
    title: "의지와 동기",
    progressDelta: 4 / 10,
    content: <Motivation_4_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 5,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_5_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 6,
    title: "의지와 동기",
    progressDelta: 5 / 10,
    content: <Motivation_6_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 7,
    title: "의지와 동기",
    progressDelta: 6 / 10,
    content: <Motivation_14_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 8,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_7_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 9,
    title: "의지와 동기",
    progressDelta: 7 / 10,
    content: <Motivation_8_V6 hideNextButton={false} version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 10,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_9_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 11,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_10_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 12,
    title: "의지와 동기",
    progressDelta: 8 / 10,
    content: <Motivation_11_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 13,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_12_V6 version={V6} />,
  },
  {
    type: "motivation",
    seqByType: 14,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_13_V6 version={V6} />,
  },
];

const resultSteps: OnboardingStep[] = [
  {
    type: "result",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Result_1_V6 version={V6} />,
  },
  {
    type: "result",
    seqByType: 2,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Surface.Highlight,
    content: <Result_2_V6 version={V6} />,
  },
  {
    type: "result",
    seqByType: 3,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Result_3_V6 version={V6} />,
  },
  {
    type: "result",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Result_4_V6 version={V6} />,
  },
  {
    type: "curriculum",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.Level3,
    content: <Curriculum_1_V6 version={V6} />,
  },
  {
    type: "product",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
  {
    type: "payment",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
];

function findIndexByStepInfo(
  steps: OnboardingStep[],
  type: string,
  seqByType: number
): number {
  return steps.findIndex(
    (step) => step.type === type && step.seqByType === seqByType
  );
}

const BASE_PATH = "/v6-onboarding";

export default function OnboardingScreenV6() {
  const { type, id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const webTestType = useRecoilValue(webTestTypeAtom);
  const userSimple = useRecoilValue(userSimpleAtom);
  const isLoading = !webTestType;

  const steps = useMemo(() => {
    return [
      ...commonPrefixSteps,
      ...mainContentSteps,
      ...habitContentSteps,
      ...approachContentSteps,
      ...motivationContentSteps,
      ...resultSteps,
      ...demographicSteps,
    ];
  }, []);

  const filteredSteps = useMemo(() => {
    if (userSimple?.paymentPageType === "m") {
      return steps.filter((step) => step.type !== "product");
    }
    return steps;
  }, [steps, userSimple?.paymentPageType]);

  const numId = parseInt(id || "0");
  const questionNumber = searchParams.get("q");

  // paymentPageType === "m" 인데 product URL로 진입한 경우 payment로 리다이렉트
  useEffect(() => {
    if (userSimple?.paymentPageType === "m" && type === "product") {
      navigate(`${BASE_PATH}/payment/1`, { replace: true });
    }
  }, [userSimple?.paymentPageType, type, navigate]);

  const currentStepIndex = Math.min(
    Math.max(findIndexByStepInfo(filteredSteps, type!!, numId), 0),
    filteredSteps.length - 1
  );

  const currentStep = filteredSteps[currentStepIndex];
  const prevStepIndex = usePrevious(currentStepIndex);

  const trackingParams = useMemo(
    () => ({
      type: `${currentStep.type}`,
      pageId: `${currentStep.seqByType}`,
    }),
    [currentStep.type, currentStep.seqByType]
  );

  const trackPromotion = useMixpanelMKT({
    eventName: "온보딩 페이지 진입",
    params: trackingParams,
    version: V6,
  });

  useEffect(() => {
    if (type === "load") return;
    if (type === "auth-loading") return;
    if (type === "curriculum") return;
    if (type === "product") return;
    if (type === "payment") return;

    trackPromotion();
  }, [type, id]);

  // 마지막으로 본 페이지 저장
  useEffect(() => {
    if (!type || !id) return;
    if (
      type === "load" ||
      type === "start" ||
      type === "auth-loading" ||
      type === "demographic"
    )
      return;
    try {
      writeLastStep({
        type,
        seqByType: parseInt(id, 10),
        q: questionNumber ? parseInt(questionNumber, 10) : undefined,
      });
    } catch (e) {
      // noop
    }
  }, [type, id, questionNumber]);

  // start/1 진입 시 마지막으로 보던 페이지로 복구
  useEffect(() => {
    if (type !== "start" || id !== "1") return;

    if (
      prevStepIndex !== undefined &&
      (prevStepIndex as number) > currentStepIndex
    ) {
      return;
    }

    try {
      const parsed = readLastStep();
      if (!parsed) return;
      const idx = findIndexByStepInfo(filteredSteps, parsed.type, parsed.seqByType);
      if (idx < 0) return;
      const query = parsed.q ? `?q=${parsed.q}` : "";
      const targetPath = `${BASE_PATH}/${parsed.type}/${parsed.seqByType}${query}`;
      const currentPath = `${BASE_PATH}/${type}/${id}${questionNumber ? `?q=${questionNumber}` : ""}`;
      if (currentPath === targetPath) return;
      navigate(targetPath, { replace: true });
    } catch (e) {
      // 파싱 실패 등은 무시
    }
  }, [type, id, questionNumber, steps, navigate, prevStepIndex, currentStepIndex]);

  const handleBack = () => {
    if (currentStepIndex <= 0) return;
    if (
      (currentStep.type === "convention" || currentStep.type === "habit") &&
      currentStep.seqByType === 2
    ) {
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 1) {
        const prevQuestion = parseInt(questionNumber!!) - 1;
        navigate(
          `${BASE_PATH}/${currentStep.type}/${currentStep.seqByType}?q=${prevQuestion}`,
          { replace: true }
        );
      } else {
        const prevStep = filteredSteps[currentStepIndex - 1];
        navigate(`${BASE_PATH}/${prevStep.type}/${prevStep.seqByType}`, {
          replace: true,
        });
      }
      return;
    }

    if (currentStep.type === "convention" && currentStep.seqByType === 3) {
      navigate(
        `${BASE_PATH}/${currentStep.type}/${currentStep.seqByType - 1}?q=17`,
        { replace: true }
      );
      return;
    }

    if (currentStep.type === "habit" && currentStep.seqByType === 3) {
      navigate(
        `${BASE_PATH}/${currentStep.type}/${currentStep.seqByType - 1}?q=9`,
        { replace: true }
      );
      return;
    }

    const prevStep = filteredSteps[currentStepIndex - 1];
    navigate(`${BASE_PATH}/${prevStep.type}/${prevStep.seqByType}`, {
      replace: true,
    });
  };

  const { setProgress, setSectionCount } = useOnboardingProgress();

  useEffect(() => {
    if (currentStep.progressDelta) {
      let ratio = 1;
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 0) {
        ratio = parseInt(questionNumber!!);
      }
      // 5개 섹션, 각 20%
      setSectionCount(5);
      if (currentStep.type === "goal") {
        setProgress(0 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "convention") {
        setProgress(20 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "habit") {
        setProgress(40 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "approach") {
        setProgress(60 + 20 * currentStep.progressDelta * ratio);
      } else if (currentStep.type === "motivation") {
        setProgress(
          Math.min(80 + 20 * currentStep.progressDelta * ratio, 100)
        );
      }
    }
  }, [currentStep, questionNumber, setProgress]);

  if (isLoading) {
    return (
      <FullPageWithCenterContentV2
        content={
          <Box
            sx={{
              display: "flex",
              height: "100vh",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor:
                currentStep?.backgroundColor !== undefined
                  ? currentStep?.backgroundColor
                  : theme.vars.palette.Background.Level1,
            }}
          >
            <CircularProgress color="neutral" />
          </Box>
        }
        backgroundColor={currentStep?.backgroundColor}
      />
    );
  }

  if (currentStep.type === "payment") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<PaymentContentV6 />}
      </div>
    );
  }

  if (currentStep.type === "product") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<ProductContentV6 />}
      </div>
    );
  }

  return currentStep.centerFullScreen === true ? (
    <FullPageWithCenterContentV2
      content={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
    />
  ) : (
    <FullPageWithHeaderAndProgress
      headerTitle={currentStep.title}
      hideHeader={currentStep.hideHeader}
      hideProgress={currentStep.hideProgress}
      body={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
      disableBack={currentStep.disableBack}
      onBack={currentStepIndex > 0 ? handleBack : undefined}
    />
  );
}
